
import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../../../BaseController';
import { FragmentNames, ScoreTiss_28ListAliases } from '../../../../codegen/index';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../../../constants/routes';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { Inject } from '@odinjs/odin';
import { PanelAPI } from '@philips-internal/oswald-ui-components';
import InformationBarUtils from '../../../commons/header/information-bar-header-utils';
import { ScoreAndIndexesService } from '../../scores-list/scores-list-service';
import { ScoresAndIndexesStatusType } from '../../score-types';

@Controller ({ component: ScoreTiss_28ListAliases.LAYOUT_SCORE_TISS_28_LIST, fragment: FragmentNames.SCORE_TISS_28_LIST })
export default class ScoreTiss28ListController extends BaseController {

  @Inject(ScoreTiss_28ListAliases.PANEL_GLOBAL_ACTIONS)
  private panelGlobalActions!: PanelAPI;

  @OnMount({ target: ScoreTiss_28ListAliases.PANEL_GLOBAL_ACTIONS })
  handlePanelGlobalActionsMount(): void {
    const allowInfo = InformationBarUtils.allowInfo && ScoreAndIndexesService.isAllowEdit;
    this.panelGlobalActions.setVisible(allowInfo);
  }

  @OnClick({ target: ScoreTiss_28ListAliases.ADD_SCORE_TISS_28_CUSTOM_DYNAMIC_BUTTON })
  handleOnClick(): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    applicationContext.redirect(
      ApplicationRoute.SCORE_TISS_28_CREATE, {
        encounterId,
        patientId,
      }
    )
  }

  @OnClick({ target: ScoreTiss_28ListAliases.DECK_SCORE_TISS_28 })
  handleOnClickCard(event: ClickEvent): void {
    const { idScoreIndexes, status } = event.value;
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    const allowInfo = InformationBarUtils.allowInfo && ScoreAndIndexesService.isAllowEdit;
    const accessViewer = ((status === ScoresAndIndexesStatusType.ACTIVE) || (!allowInfo))
    const route = accessViewer ? ApplicationRoute.SCORE_TISS_28_VIEWER : ApplicationRoute.SCORE_TISS_28_EDIT;

    applicationContext.redirect(route, {
      encounterId,
      idScoreIndexes,
      patientId,
    });
  }
}
